module.exports = __webpack_public_path__ + "img/avbi04b.ee182125.png";